// @flow
import React, {useMemo} from 'react';
import Box from "@mui/material/Box";
import useUserData from "../../../../../../../hooks/user/useUserData";
import {muiGridLocales} from "../../../../../../../helpers/muiGridLocales";
import {DataGridPremium, GridToolbar} from "@mui/x-data-grid-premium";
import {formatDate} from "../../../../../../../helpers/date";
import { reportGridsSx } from "../../helpers";

type Props = {};

const KpisExhibition = (props: Props) => {
	const {loading, data, t, isCoorganization, generalReport} = props
	const {language, dateFormat} = useUserData()
	
	const columns = useMemo(() => [
			...(generalReport ? [{
				field: 'exhibition',
				description: t('Exhibition'),
				headerName: t('Exhibition'),
				minWidth: 200,
				flex: 1
			}] : []),
			...(generalReport ? [{
				field: 'coorganization',
				description: t('Coorganization'),
				headerName: t('Coorganization'),
				minWidth: 200,
				flex: 1
			}] : []),
			{
				field: 'exhibitionStartDt',
				description: t('Exhibition Date'),
				headerName: t('Exhibition Date'),
				width: 180,
				valueFormatter: (value, row, column, apiRef) => {
					return `${formatDate(value, dateFormat)}`
				}
			},
			{
				field: 'exhibitorScanners',
				description: t('exhibitorScanners_info'),
				headerName: t('exhibitorScanners'),
				minWidth: 200,
				flex: 1,
				type: 'number'
			},
			{
				field: 'preregistrationTotalCount',
				description: t('preregistrationTotalCount_info'),
				minWidth: 200,
				headerName: t('preregistrationTotalCount'),
				flex: 1,
				type: 'number'
			},
			{
				field: 'preregistrationVisitorCount',
				description: t('preregistrationVisitorCount_info'),
				minWidth: 200,
				headerName: t('preregistrationVisitorCount'),
				flex: 1,
				type: 'number'
			},
			{
				field: 'erpTotalCount',
				description: t('erpTotalCount_info'),
				headerName: t('erpTotalCount'),
				flex: 1,
				minWidth: 200,
				type: 'number'
			},
			{
				field: 'notErpTotalCount',
				description: t('notErpTotalCount_info'),
				headerName: t('notErpTotalCount'),
				minWidth: 200,
				flex: 1,
				type: 'number'
			},
			...(!isCoorganization ? [{
					field: 'scannedAfterRegistration',
					description: t('scannedAfterRegistration_info'),
					headerName: t('scannedAfterRegistration'),
					minWidth: 200,
					flex: 1,
					type: 'number'
				}] : []
			),
			{
				field: 'erpVisitorCount',
				description: t('erpVisitorCount_info'),
				headerName: t('erpVisitorCount'),
				minWidth: 200,
				flex: 1,
				type: 'number'
			},
			{
				field: 'notErpVisitorCount',
				description: t('notErpVisitorCount_info'),
				headerName: t('notErpVisitorCount'),
				minWidth: 200,
				flex: 1,
				type: 'number'
			},
			{
				field: 'totalNoActualVisitors',
				description: t('Total Visitors = Actual Visits From Visitors Submitted Through ERP + Actual Visits From Non ERP Submitted Visitors'),
				headerName: t('Total Number Of Actual Visitors'),
				flex: 1,
				minWidth: 200,
				type: 'number',
				valueGetter: (value, row, column, apiRef) => {
					return row.erpVisitorCount + row.notErpVisitorCount
				},
			},
		],
		[dateFormat, generalReport, isCoorganization, t]
	)
	
	return (
		<Box style={{height: 400, width: '100%', maxWidth: '100%'}}>
			<DataGridPremium
				sx={reportGridsSx}
				loading={loading}
				initialState={{
					density: "standard"
				}}
				localeText={muiGridLocales(language)}
				rows={data}
				columns={columns}
				slots={{
					toolbar: GridToolbar
				}}
				slotProps={{toolbar: {csvOptions: {disableToolbarButton: true}}}}
			/>
		</Box>
	);
};

export default KpisExhibition